import { render, staticRenderFns } from "./email-verification-2.vue?vue&type=template&id=af477ac4&scoped=true"
import script from "./email-verification-2.vue?vue&type=script&lang=js"
export * from "./email-verification-2.vue?vue&type=script&lang=js"
import style0 from "./email-verification-2.vue?vue&type=style&index=0&id=af477ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af477ac4",
  null
  
)

export default component.exports